module.exports = __webpack_public_path__ + "static/media/oil-can.20237898.svg";